module.exports = __webpack_public_path__ + "static/media/bg-about-us-4.1b6be9af.jpg";